import React, { useRef } from "react";
import styles from "styles.module.css";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { fisheryDepartmentNoteGridColumns } from "./utilities/columnGrid";
import { PageTypePath } from "utils/pages";
import { FisheryDepartmentNote } from "interface/registration";
import GridWithGroupPaging from "ui/grid/GridWithGroupPaging";
import Filter from "./utilities/Filter";

interface FisheryDepartmentNotesProps {
	id: number;
	title: string;
	apiMethod: (id: number) => Promise<any>;
}

const FisheryDepartmentNotes: React.FC<FisheryDepartmentNotesProps> = ({
	id,
	title,
	apiMethod,
}) => {
	const excelRef = useRef<ExcelExport>(null);

	const exportAsExcel = () => {
		if (excelRef.current !== null) {
			excelRef.current.save();
		}
	};

	const handlePrint = (item: FisheryDepartmentNote) => {
		if (item.reportGuid) {
			window.open(`/${PageTypePath.Pdf}/${item.reportGuid}`, "_blank");
		}
	};

	return (
		<div className={styles.PageContainer}>
			<div className="page-header">
				<legend className={styles.BoxHeadingLarge}>{title}</legend>
			</div>
			<Filter exportAsExcel={exportAsExcel} />
			<GridWithGroupPaging
				gridColumns={fisheryDepartmentNoteGridColumns({ onPrint: handlePrint })}
				apiMethod={() => apiMethod(id).then((res) => res?.data ?? [])}
				filter={id}
				pageable={false}
				itemAboveHeight={100}
				exportGridAsExcelRef={excelRef}
			/>
		</div>
	);
};

export default FisheryDepartmentNotes;
